export const CLONAL_SNP_THRESHOLD = 25;
export const CLOSELY_RELATED_SNP_THRESHOLD = 60;
